import {
  HerdScenario,
  isHerdScenario,
  isHerdScenarioValid,
} from "./cow-model-parameters.model";
import { getGroupValidation, Group } from "./group.model";
import {
  FlockScenario,
  isFlockScenario,
  isFlockScenarioValid,
} from "./sheep-model-parameters.model";

export interface DataModel {
  kind?: "cows" | "sheep";
  group?: Group;
  scenario?: HerdScenario | FlockScenario;
  forecastName?: string;
}

export function isModelValid(model: DataModel) {
  if (model.group === undefined) return false;

  const [isGroupValid] = getGroupValidation(model.group);
  if (!isGroupValid) return false;

  if (model.kind === "cows" && isHerdScenario(model.scenario)) {
    return isHerdScenarioValid(model.scenario);
  } else if (model.kind === "sheep" && isFlockScenario(model.scenario)) {
    return isFlockScenarioValid(model.scenario);
  }
  return false;
}
